module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-main"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', {
    staticClass: "breadcrumb-item active"
  }, [_vm._v(_vm._s(_vm.currentPage === 'admin' ? 'Admin' : 'Reseller'))])]), _vm._v(" "), _c('h1', {
    staticClass: "page-title"
  }, [_vm._v(_vm._s(_vm.$t("action.manageClientTeam")))]), _vm._v(" "), _c('div', {
    staticClass: "page-header-actions"
  }, [_c('div', {
    staticClass: "row no-space w-120"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('div', {
    staticClass: "counter"
  }, [_c('div', {
    staticClass: "counter-label p-t-5"
  }, [_vm._v(_vm._s(_vm.$t("text.totalTeams")))]), _vm._v(" "), _c('span', {
    staticClass: "counter-number font-weight-medium"
  }, [_vm._v(_vm._s(_vm.total_team))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-body panel-form"
  }, [(_vm.isLoading) ? _c('loading-indicator') : (_vm.isError) ? _c('div') : _c('div', [_c('div', {
    staticClass: "p-b-15"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6 col-md-6"
  }, [_c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": ("/" + (_vm.$route.params.namespace) + "/" + _vm.currentPage + "/teams/create")
    }
  }, [_c('i', {
    staticClass: "icon md-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', {
    staticClass: "text hidden-sm-down"
  }, [_vm._v(" " + _vm._s(_vm.$t("clientUsageHistory.action.create")) + " ")])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "p-b-15"
  }, [_c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.filterItems($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.showFilterItems) ? _c('div', {
    staticClass: "col-xs-4 col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-control-label"
  }, [_vm._v("Pay Plan")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentPayPlanType),
      expression: "currentPayPlanType"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        _vm.currentPayPlanType = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Show all")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "prepaid"
    }
  }, [_vm._v("Pre paid")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "postpaid"
    }
  }, [_vm._v("Post paid")])])])]) : _vm._e(), _vm._v(" "), (_vm.showFilterItems) ? _c('div', {
    staticClass: "col-xs-4 col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-control-label"
  }, [_vm._v("Pricing Plan")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentPricingPlanType),
      expression: "currentPricingPlanType"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        _vm.currentPricingPlanType = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Show all")]), _vm._v(" "), _vm._l((_vm.pricingplanList), function(item, index) {
    return _c('option', {
      domProps: {
        "value": item.alias
      }
    }, [_vm._v(_vm._s(item.name))])
  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.showFilterItems) ? _c('div', {
    staticClass: "col-xs-4 col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-control-label"
  }, [_vm._v("Suspend")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentSuspendType),
      expression: "currentSuspendType"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        _vm.currentSuspendType = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Show all")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Suspend")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Active")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-control-label"
  }, [_vm._v(_vm._s(_vm.$t("text.textGuideFilter")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentName),
      expression: "currentName"
    }],
    staticClass: "form-control input-lg",
    attrs: {
      "type": "text",
      "id": "team",
      "placeholder": ""
    },
    domProps: {
      "value": _vm._s(_vm.currentName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentName = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-success m-t-35",
    class: {
      'btn-default': _vm.isSubmiting
    },
    attrs: {
      "type": "submit",
      "disabled": _vm.isSubmiting
    }
  }, [(_vm.isSubmiting) ? _c('div', {
    staticClass: "loader vertical-align-middle loader-circle loader-form"
  }) : _vm._e(), _vm._v(_vm._s(_vm.$t("action.search")))])])])])]), _vm._v(" "), (_vm.total_team) ? _c('div', {
    staticClass: "table-striped table-hover table-responsive"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "cell-50"
  }, [_vm._v("ID")]), _vm._v(" "), _c('th', {
    staticClass: "cell-300"
  }, [_vm._v(_vm._s(_vm.$t("manageClientTeam.labels.name")))]), _vm._v(" "), _c('th', {
    staticClass: "cell-300"
  }, [_vm._v(_vm._s(_vm.$t("manageClientTeam.labels.url")))]), _vm._v(" "), _c('th', {
    staticClass: "cell-100"
  }, [_vm._v(_vm._s(_vm.$t("manageClientTeam.labels.type")))]), _vm._v(" "), _c('th', {
    staticClass: "cell-100 text-xs-center"
  }, [_vm._v(_vm._s(_vm.$t("manageClientTeam.labels.reseller")))]), _vm._v(" "), _c('th', {
    staticClass: "cell-100"
  }, [_vm._v(_vm._s(_vm.$t("manageClientTeam.labels.payPlan")))]), _vm._v(" "), _c('th', {
    staticClass: "cell-50"
  }), _vm._v(" "), _c('th', {
    staticClass: "cell-50"
  })])]), _vm._v(" "), _c('tbody', _vm._l((_vm.teams), function(team, index) {
    return _c('tr', {
      attrs: {
        "id": team.id
      }
    }, [_c('td', {
      staticClass: "cell-50"
    }, [_vm._v(_vm._s(team.id))]), _vm._v(" "), _c('td', {
      staticClass: "cell-300"
    }, [_vm._v(_vm._s(team.name))]), _vm._v(" "), _c('td', {
      staticClass: "cell-300"
    }, [_vm._v(_vm._s(team.namespace))]), _vm._v(" "), _c('td', {
      staticClass: "cell-100"
    }, [(team.is_reseller) ? _c('span', {
      staticClass: "tag tag-danger"
    }, [_vm._v("Reseller")]) : (team.has_reseller) ? _c('span', {
      staticClass: "tag tag-info"
    }, [_vm._v("Sub Team")]) : _c('span', {
      staticClass: "tag tag-default"
    }, [_vm._v("Normal")])]), _vm._v(" "), _c('td', {
      staticClass: "cell-100 text-xs-center"
    }, [(team.has_reseller) ? _c('router-link', {
      staticClass: "btn btn-link",
      attrs: {
        "to": ("/" + (_vm.$route.params.namespace) + "/" + _vm.currentPage + "/teams/" + (team.reseller.namespace) + "/billings"),
        "alt": "Reseller"
      }
    }, [_vm._v(_vm._s(team.reseller.name) + "\n                    ")]) : _c('span', {
      staticClass: "text-center"
    }, [_vm._v("-")])], 1), _vm._v(" "), _c('td', {
      staticClass: "cell-100"
    }, [(team.pay_plan === 'postpaid') ? _c('span', {
      staticClass: "red-600"
    }, [_vm._v(_vm._s(_vm.$t("payPlan.labels.postPaid")))]) : _c('span', [_vm._v(_vm._s(_vm.$t("payPlan.labels.prePaid")))])]), _vm._v(" "), _c('td', {
      staticClass: "cell-50 text-nowrap"
    }, [_c('router-link', {
      staticClass: "btn btn-sm btn-default",
      attrs: {
        "to": ("/" + (_vm.$route.params.namespace) + "/" + _vm.currentPage + "/teams/" + (team.namespace) + "/billings"),
        "alt": "Billing"
      }
    }, [_vm._v(_vm._s(_vm.$t("menu.billing")) + "\n                    ")])], 1), _vm._v(" "), _c('td', {
      staticClass: "cell-50 text-nowrap"
    }, [_c('router-link', {
      staticClass: "btn btn-sm btn-default",
      attrs: {
        "to": ("/" + (_vm.$route.params.namespace) + "/" + _vm.currentPage + "/teams/" + (team.namespace) + "/edit"),
        "alt": "Edit"
      }
    }, [_vm._v(_vm._s(_vm.$t("action.manage")) + "\n                    ")])], 1)])
  }))])]) : _c('div', {
    staticClass: "alert alert-primary alert-dismissible"
  }, [_vm._v("\n            There is no team.\n          ")])]), _vm._v(" "), _c('paginate', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.pagination.total_page > 1)),
      expression: "(pagination.total_page > 1)"
    }],
    attrs: {
      "pageCount": _vm.pagination.total_page,
      "prevText": '«',
      "nextText": '»',
      "clickHandler": _vm.changePage,
      "containerClass": 'pagination pull-right',
      "pageClass": 'page-item',
      "pageLinkClass": 'page-link',
      "prevClass": 'page-item',
      "prevLinkClass": 'page-link',
      "nextClass": 'page-item',
      "nextLinkClass": 'page-link'
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-08df39a2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/teams/TeamBrowser.vue
// module id = 502
// module chunks = 1